import type * as React from "react";

import { type ControlSize, controlVariants } from "./control-variants";
import { cn } from "./utils";

type InputProps = React.ComponentProps<"input"> & {
  controlSize?: ControlSize;
  numeric?: boolean;
};

function Input({ className, controlSize, numeric = false, type, ...props }: InputProps) {
  const resolvedClassName = cn(
    controlVariants({ size: controlSize }),
    "flex min-w-0 px-3 py-1 text-base selection:bg-primary selection:text-primary-foreground file:inline-flex file:h-7 file:border-0 file:bg-transparent file:font-medium file:text-foreground file:text-sm disabled:pointer-events-none md:text-sm",
    className,
  );

  return (
    <input
      className={numeric ? `${resolvedClassName} text-numeric` : resolvedClassName}
      data-slot="input"
      type={type}
      {...props}
    />
  );
}

export { Input };
